<template>
  <v-layout class="date-picker" row wrap>
    <v-menu
      v-model="fromDateMenu"
      v-validate="validations"
      :close-on-content-click="false"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      max-width="290px"
      min-width="290px">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :label="label"
          prepend-icon="event"
          @click:prepend="on.click()"
          readonly
          v-bind="attrs"
          :value="date"
          v-on="on"
          v-model="computedDateFormatted">
        </v-text-field>
      </template>
      <v-date-picker
        locale="en-in"
        :min="minDate"
        :max="maxDate"
        v-model="date"
        no-title
        @input="fromDateMenu = false">
      </v-date-picker>
    </v-menu>
  </v-layout>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    label: {
      type: String,
      default: '',
    },
    validations: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: [String, Number],
      default: '',
    },
    maxDate: {
      type: [String],
    },
  },
  data() {
    return {
      fromDateMenu: false,
      minDate: '',
      date: '',
      dateFormatted: this.formatDate((new Date(Date.now()
        - (new Date()).getTimezoneOffset() * 60000))
        .toISOString().substr(0, 10)),
    };
  },
  mounted() {
    this.minDate = this.getFormattedDateValue();
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    getFormattedDateValue() {
      return (new Date(Date.now() - (new Date())
        .getTimezoneOffset() * 60000))
        .toISOString().substr(0, 10);
    },
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
      this.$emit('input', this.dateFormatted);
    },
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';

</style>
